import { CommonModule } from '@angular/common';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { LayoutComponent } from './components/layout.component';
import { ErrorPageComponent } from './components/error-page.component';
import { CoreModule } from '@app/core/core.module';
import { LayoutsService } from './services/layouts.service';
import { RouterModule } from '@app/router/router.module';
import { ImageModule } from '@app/image/image.module';
import { AdsModule } from '@app/ads/ads.module';
import { MatchComponent } from '@app/match/components/match.component';
@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RouterModule,
        ImageModule,
        AdsModule,
        MatchComponent
    ],
    declarations: [
        LayoutComponent,
        ErrorPageComponent,
    ],
    providers: [ LayoutsService ]
})
export class LayoutsModule { }
